import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

// Updated categories with images
const categories = [
  {
    name: "Courses",
    path: "/courses",
    image: "https://i.ibb.co/SXZzzRQn/courses.jpg",
  },
  {
    name: "Mega Bundle Resources",
    path: "/resources",
    image: "https://media.istockphoto.com/id/1365310330/photo/excited-young-indian-man-winner-using-smartphone-isolated-on-yellow-background.jpg?s=612x612&w=0&k=20&c=mbCnh1Bd715P9JSdqrllYYmshIyfDkgafYPK53_S-m0=",
  },
  
  {
    name: "Premium Tools",
    path: "/tools",
    image: "https://i.ibb.co/V0zpd6bm/1621681958900.jpg",
  },
  {
    name: "Books",
    path: "/books",
    image: "https://i.ibb.co/Gf02bgKL/Essential-Books.jpg",
  },
  {
    name: "Audio Books",
    path: "/audiobooks",
    image:
      "https://i.ibb.co/gbvYxCXc/listening-audiobook-marc-verch-kostenlose-fotos.jpg",
  },
  {
    name: "Entertainment",
    path: "/entertainment",
    image: "https://i.ibb.co/vCRWT7jQ/462603-4381654-updates.jpg",
  },
  {
    name: "Anime",
    path: "/anime",
    image: "https://i.ibb.co/20DHxJvD/istockphoto-1166651462-612x612.jpg",
  },
  {
    name: "Softwares & Apps",
    path: "/software",
    image: "https://i.ibb.co/PzhVVczy/types-of-software.webp",
  },
  {
    name: "Games",
    path: "/games",
    image: "https://i.ibb.co/ccC4pNS7/2-D3-D-Game-Design.webp",
  },
  {
    name: "Wallpapers",
    path: "/wallpapers",
    image: "https://i.ibb.co/9910C1Jz/pngtree-small-white-house-on-grass-real-estate-sale-or-property-investment-image-15715451.jpg",
  },
  {
    name: "Islamic Collection (Free)🎉  🥳  🙌",
    path: "/islamic",
    image: "https://i.ibb.co/cXY3vkwk/beautiful-islamic-mosque-landscape-crescent-moon-background-illustration-photo.jpg",
  },
  {
    name: "English Language Collection",
    path: "/english",
    image: "https://i.ibb.co/wh6SVmjt/istockphoto-1047570732-612x612.jpg",
  },
];

const Home = () => {
  return (
    <Box sx={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      {/* Hero Section */}
      <Box
        sx={{
          height: "60vh",
          background: `
            linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.6)),
            url('https://i.ibb.co/Ng9Bxhym/retrosupply-j-Lw-VAUt-LOAQ-unsplash.jpg')
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <Box sx={{ maxWidth: "800px" }}>
          <Typography
            variant="h2"
            fontWeight="bold"
            gutterBottom
            sx={{
              letterSpacing: "2px",
              textTransform: "uppercase",
              textShadow: "2px 2px 8px rgba(0, 0, 0, 0.5)",
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              fontFamily: '"Montserrat", sans-serif', // Modern font
            }}
          >
            Welcome to the Premium Collection
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              opacity: 0.9,
              mb: 4,
              fontSize: { xs: "1.1rem", md: "1.3rem" },
              textShadow: "1px 1px 4px rgba(0, 0, 0, 0.3)",
              fontFamily: '"Montserrat", sans-serif', // Consistent font
            }}
          >
            Unlock exclusive access to premium courses, tools, books, entertainment, and more. Elevate your experience with our curated collection.
          </Typography>
          <Button
            variant="contained"
            size="large"
            component={Link}
            to="/buy-premium"
            sx={{
              fontSize: "1.1rem",
              fontWeight: 700,
              px: 4,
              py: 1.5,
              borderRadius: "50px",
              background: "linear-gradient(45deg, #ff6b6b, #ff8e53)",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
              fontFamily: '"Montserrat", sans-serif', // Consistent font
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 6px 12px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            Get Premium Access
          </Button>
        </Box>
      </Box>

      {/* Demo Video Section */}
      <Box sx={{ py: 8, px: { xs: 2, md: 6 }, backgroundColor: "white" }}>
        <Typography
          variant="h3"
          textAlign="center"
          fontWeight="bold"
          gutterBottom
          sx={{
            mb: 6,
            background: "linear-gradient(45deg, #2c3e50, #3498db)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: { xs: "2rem", md: "2.5rem" },
            fontFamily: '"Montserrat", sans-serif', // Modern font
          }}
        >
          Watch Our Demo Video
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "15px",
            overflow: "hidden",
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <iframe
            src="https://drive.google.com/file/d/1l_4Vw1z1shmg-In03_q7qf1htzyXh3GK/preview"
            width="100%"
            height="450"
            allow="autoplay"
            style={{ border: "none" }}
          ></iframe>
        </Box>
      </Box>

      {/* Premium Collection Stats Section */}
      <Box sx={{ py: 8, px: { xs: 2, md: 6 }, backgroundColor: "white" }}>
        <Typography
          variant="h3"
          textAlign="center"
          fontWeight="bold"
          gutterBottom
          sx={{
            mb: 6,
            background: "linear-gradient(45deg, #2c3e50, #3498db)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: { xs: "2rem", md: "2.5rem" },
            fontFamily: '"Montserrat", sans-serif', // Modern font
          }}
        >
          Premium Collection Stats
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {[
            { title: "Videos", value: "50,000+", description: "HD Quality" },
            { title: "Documents", value: "1,00,000+", description: "PDF and other document files" },
            { title: "Audio Files", value: "3500+", description: "Crystal Clear" },
            { title: "Pictures", value: "20,000+", description: "High Resolution" },
            { title: "Zip Files", value: "50,000+", description: "Organized" },
            { title: "Links", value: "25,000+", description: "Curated Resources" },
          ].map((stat, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Card
                sx={{
                  textAlign: "center",
                  p: 3,
                  borderRadius: "15px",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 12px 24px rgba(0, 0, 0, 0.2)",
                  },
                }}
              >
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  sx={{ color: "primary.main", fontFamily: '"Montserrat", sans-serif' }}
                >
                  {stat.value}
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="600"
                  sx={{ mt: 1, color: "text.primary", fontFamily: '"Montserrat", sans-serif' }}
                >
                  {stat.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mt: 1, color: "text.secondary", fontFamily: '"Montserrat", sans-serif' }}
                >
                  {stat.description}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Category Section */}
      <Box sx={{ py: 8, px: { xs: 2, md: 6 }, backgroundColor: "#f8f9fa" }}>
        <Typography
          variant="h3"
          textAlign="center"
          fontWeight="bold"
          gutterBottom
          sx={{
            mb: 6,
            background: "linear-gradient(45deg, #2c3e50, #3498db)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: { xs: "2rem", md: "2.5rem" },
            fontFamily: '"Montserrat", sans-serif', // Modern font
          }}
        >
          Explore Categories
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {categories.map((category) => (
            <Grid item key={category.name} xs={12} sm={6} md={4} lg={3}>
              <Card
                sx={{
                  borderRadius: "15px",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 12px 24px rgba(0, 0, 0, 0.2)",
                  },
                }}
              >
                <CardActionArea component={Link} to={category.path}>
                  <CardMedia
                    component="img"
                    height="180"
                    image={category.image}
                    alt={category.name}
                    sx={{
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                      objectFit: "cover",
                    }}
                  />
                  <CardContent
                    sx={{
                      textAlign: "center",
                      backgroundColor: "#ffffff",
                      borderBottomLeftRadius: "15px",
                      borderBottomRightRadius: "15px",
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{ color: "primary.main", fontFamily: '"Montserrat", sans-serif' }}
                    >
                      {category.name}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Home;